module.exports = __webpack_public_path__ + "static/q-d6ca36b4d0d3df68f843a94d023d3c3b.png";